import React from 'react';

import { type MotionProps } from 'framer-motion';
import { Link } from 'react-router-dom';

import { Icon, type IconsType } from '../Icon';
import { Emoji } from '../styles';

import { Count, IconLink, Text, Wrapper } from './styles';

interface NavButtonProps extends MotionProps {
    to?: string;
    children?: React.ReactNode;
    icon?: IconsType;
    count?: string | number;
    onClick?: () => void;
    newTab?: boolean;
    emoji?: string;
    isChild?: boolean;
    isActive?: boolean;
    isMainButton?: boolean;
    state?: Record<string, unknown>;
}

export const NavButton = ({
    to,
    children,
    icon,
    emoji,
    count,
    isChild,
    newTab,
    onClick,
    isActive,
    isMainButton,
    state,
    ...rest
}: NavButtonProps) => {
    if (!children && !onClick) {
        // If there are no children, show the Icon button
        return (
            <>
                {to && (
                    <IconLink as={Link} to={to} $isActive={isActive}>
                        {icon && <Icon name={icon} />}
                        {emoji && <Emoji emojiID={emoji} aria-hidden />}
                    </IconLink>
                )}
                {!to && (
                    <IconLink $isActive={isActive}>
                        {icon && <Icon name={icon} />}
                        {emoji && <Emoji emojiID={emoji} aria-hidden />}
                    </IconLink>
                )}
            </>
        );
    }

    const renderButtonInside = () => {
        return (
            <>
                {icon && <Icon name={icon} />}
                {emoji && <Emoji emojiID={emoji} aria-hidden />}
                {children && <Text>{children}</Text>}
                {Boolean(count) && <Count aria-hidden>{count}</Count>}
            </>
        );
    };

    return (
        <Wrapper $isMainButton={isMainButton} $isActive={isActive} $isChild={isChild} {...rest}>
            {to && newTab && (
                <a href={to} target="_blank" rel="noopener noreferrer" onClick={onClick && onClick}>
                    {renderButtonInside()}
                </a>
            )}
            {to && !newTab && (
                <Link to={to} onClick={onClick && onClick} state={state}>
                    {renderButtonInside()}
                </Link>
            )}
            {!to && onClick && <button onClick={onClick}>{renderButtonInside()}</button>}
        </Wrapper>
    );
};
